"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lenderNameSchema = void 0;
exports.lenderNameSchema = {
    type: 'object',
    required: [],
    properties: {
        approvedLenderEnglishName: { type: ['string', 'null'] },
        approvedLenderFrenchName: { type: ['string', 'null'] },
        loanDetailApprovedLenderEnglishName: { type: ['string', 'null'] },
        loanDetailApprovedLenderFrenchName: { type: ['string', 'null'] },
    },
};
